'use client';
import { Content, TopTitle, BackButton } from '@/components';
import style from './style.module.scss';
import { CheckButtons } from './widgets';
import { useSearchParams } from 'next/navigation';
import { PostersMedia, VideosMedia } from './ui';
const Media = () => {
  const searchParams = useSearchParams();
  const type = searchParams.get('type');

  return (
    <div>
      <div className={style.topWrapper}>
        <TopTitle text="Медиа" />
        <div className={style.top}>
          <BackButton link={'/'} />
          <CheckButtons />
        </div>
      </div>

      <Content>
        {type === 'image' && <PostersMedia />}
        {type === 'video' && <VideosMedia />}
      </Content>
    </div>
  );
};

export default Media;
